xx/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">支付管理</el-breadcrumb-item>
      <el-breadcrumb-item>账单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="业务类型：">
        <el-select size="small" v-model="formInline.businessType" placeholder="请选择业务类型" clearable>
          <el-option label="全部" value=""/>
          <el-option label="帖子置顶" value="POST_TOP"/>
          <el-option label="跑腿订单" value="RUN_ERRANDS"/>
        </el-select>
      </el-form-item>
      <el-form-item label="支付状态：">
        <el-select size="small" v-model="formInline.status" placeholder="请选择状态" clearable>
          <el-option label="全部" value=""/>
          <el-option v-for="type in orderStatus" :label="type.key" :value="type.value" :key="type.value"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="orderTable" :data="orderList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="outTradeNo" label="业务支付编码" width="150" show-overflow-tooltip fixed/>
      <el-table-column align="center" prop="businessTypeName" label="业务类型" width="100" show-overflow-tooltip/>
      <el-table-column align="center" prop="userName" label="支付人" width="100" show-overflow-tooltip/>
      <el-table-column align="center" prop="amount" label="支付金额" width="100" :formatter="amountFormat"/>
      <el-table-column align="center" prop="payTime" label="支付创建时间" width="150" show-overflow-tooltip/>
      <el-table-column align="center" prop="paySuccessTime" label="支付成功时间" show-overflow-tooltip/>
      <el-table-column align="center" prop="transactionId" label="微信支付订单号" show-overflow-tooltip/>
      <el-table-column align="center" prop="outRefundNo" label="业务退款编号" show-overflow-tooltip/>
      <el-table-column align="center" prop="refundId" label="微信退款订单号" show-overflow-tooltip/>
      <el-table-column align="center" prop="refundTime" label="退款申请时间" show-overflow-tooltip/>
      <el-table-column align="center" prop="refundSuccessTime" label="退款成功时间" show-overflow-tooltip/>
      <el-table-column align="center" prop="channel" label="退款渠道" width="100" :formatter="channelFormat" show-overflow-tooltip/>
      <el-table-column align="center" prop="status" label="支付状态" width="100" :formatter="statusFormat" fixed="right"/>
    </el-table>
    <!-- 新增一个dialog用于输入备注 -->
    <el-dialog title="备注" :visible.sync="dialogVisible" width="30%" @close="resetDialog">
      <el-input v-model="remark" placeholder="请输入酒店订单号或取消原因"></el-input>
      <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmChangeStatus">确认</el-button>
    </span>
    </el-dialog>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageParam" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import {orderList, getById} from '../../api/orderMG'
import Pagination from '../../components/Pagination'
import {hotelSelect} from "../../api/hotelMg";

export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      user: {},
      orderStatus: [
        {key: '待支付', value: 0},
        {key: '已支付', value: 1},
        {key: '退款中', value: 2},
        {key: '已退款', value: 3}
      ],
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      hotelSelect: [], //酒店下拉列表
      formInline: {
        page: 1,
        limit: 20,
        status: "",
        businessType: ""
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      orderList: [], //用户数据
      // 分页参数
      pageParam: {
        currentPage: 1,
        pageSize: 20,
        total: 20
      },
      dialogVisible: false, // 控制dialog的显示隐藏
      remark: '',//备注
      operationHint: '',
      status: '' //订单状态
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.queryHotelList();
    this.getdata(this.formInline);
    this.user = JSON.parse(localStorage.getItem('userdata'));
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //钱格式化显示
    moneyFormatter: function (row, column, cellValue) {
      return cellValue + " 元";
    },
    //查询酒店列表
    queryHotelList: function () {
      hotelSelect().then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          res.result.forEach(item => {
            this.hotelSelect.push(item);
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: res.message
        })
      })
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      orderList(parameter).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({type: 'info', message: res.msg})
        } else {
          this.orderList = res.data.list
          // 分页赋值
          this.pageParam.currentPage = res.data.page
          this.pageParam.pageSize = res.data.limit
          this.pageParam.total = res.data.total
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('订单加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(param) {
      this.formInline.page = param.currentPage
      this.formInline.limit = param.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //支付金额
    amountFormat(row) {
      return row.amount + " 元";
    },
    //退款渠道
    channelFormat(row) {
      if (row.channel == 'ORIGINAL') {
        return "原路退款"
      } else if (row.channel == 'BALANCE') {
        return "退回到余额"
      } else if (row.channel == 'OTHER_BALANCE') {
        return "原账户异常退到其他余额账户"
      } else if (row.channel == 'OTHER_BANKCARD') {
        return "原银行卡异常退到其他银行卡"
      }
    },
    //订单状态：0-待支付 1-已支付 2-退款中 3-已退款
    statusFormat(row) {
      if (row.status == 0) {
        return "待支付"
      } else if (row.status == 1) {
        return "已支付"
      } else if (row.status == 2) {
        return "退款中"
      } else if (row.status == 3) {
        return "已退款"
      }
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    changeOrderStatus: function (index, id, status, remark) {
      // this.loading = true
      let parm = {
        status: '',
        id: '',
        orderRemark: '',
        token: localStorage.getItem('logintoken')
      }
      parm.id = id
      parm.status = status
      if (status === '1') {
        this.operationHint = '确认恢复订单?';
      } else {
        parm.orderRemark = remark
      }
      let type = "success";
      if (4 == status) {
        type = 'warning'
      }
      this.$confirm(this.operationHint, '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type
      }).then(() => {
        // 修改状态
        editOrderStatus(parm).then(res => {
          this.loading = false
          if (!res.success) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '订单删除成功'
            })
            this.getdata(this.formInline)
          }
        })
      })
    },
    orderDelete: function (index, id) {
      this.$confirm("订单删除无法撤回，确认删除？", '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: "warning"
      }).then(() => {
        //订单删除
        orderDelete(id).then(res => {
          this.loading = false
          if (!res.success) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '状态修改成功'
            })
            this.getdata(this.formInline)
          }
        })
      })
    },
    // 显示输入备注的dialog
    showRemarkDialog(index, row, status, operationHint) {
      this.dialogVisible = true;
      this.operationHint = operationHint;
      this.status = status;
      this.id = row.id;
      // 可以在这里根据需要设置row信息，以便后续操作
    },

    // 点击dialog中的确认按钮，执行状态变更
    confirmChangeStatus() {
      if (!this.remark.trim()) {
        this.$message.warning('请先输入备注信息！');
        return; // 如果备注为空，则不执行后续操作
      }
      this.changeOrderStatus(this.selectedIndex, this.id, this.status, this.remark);
      this.dialogVisible = false;
      this.resetDialog();
    },

    // 重置dialog内容
    resetDialog() {
      this.remark = ''; // 清空备注输入框
      // 可能还需要重置其他状态，比如selectedIndex, selectedRow等
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/order/order.vue